module.exports = __webpack_public_path__ + "img/footer-image@2x.efb9fa2a.webp";